<template>
	<div :tabindex="clickable && 0" data-component="icon">
		<simple-svg
			:filepath="imgUrl"
			:fill="iconColor"
			:height="dimensions"
			:width="dimensions"
			data-element="svg-icon"
			role="img"
			:alt="alt"
			:data-size="size"
			:data-clickable="clickable"
		/>
	</div>
</template>

<script>

	export default {
		props: [ 'size', 'icon', 'clickable', 'alt', 'iconColor' ],
		computed: {
			imgUrl () {
				return require(`@/assets/img/icons/${this.icon}.svg`);
			},
			dimensions () {
				switch (this.size) {
					case 'xxs':
						return '14px';
					case 'xs':
						return '18px';
					case 'sm':
						return '20px';
					case 'md':
						return '24px';
					case 'lg':
						return '27px';
					case 'xl':
						return '30px';
					default:
						return '24px';
				}
			}
		}
	}

</script>

<style lang="scss" scoped>

	[data-component='icon'] {
		display:inline-flex;
		&:focus {
			outline-color:#fff;
		}
		[data-element='svg-icon'] {
			display:inline-flex;
			flex-shrink:0;
			// md is default size
			width:24px;
			border: none;
			background-color:transparent;

			&:active, &:focus {
				outline:none;
			}
			&[data-clickable] {
				cursor:pointer;
				/deep/ svg {
					&:focus {
						outline:medium invert #fff;
					}
				}
			}
			&[data-size='xxs'] {
				width:16px;
			}
			&[data-size='xs'] {
				width:18px;
			}
			&[data-size='sm'] {
				width:20px;
			}
			&[data-size='md'] {
				// md is default size
			}
			&[data-size='lg'] {
				width:27px;
			}
		}
	}

</style>
